<div class="container-fluid">
    <div style="min-height: 200px;">
        <div class="question">
            <div class="question-text" [innerHTML]="getSafeHtml(question.questionText)"></div>
            <mat-icon color="accent" title="Help" class="question-tooltip" *ngIf="question.tooltip"
                (click)="questionTooltip(question.tooltip)">help_outline</mat-icon>
        </div>
        <!-- TODO: Consider using question.isApproachQuestion instead -->
        <div class="requirements-link py-2 px-2" *ngIf="questions.length > 0 && question === questions[0]">
            <a routerLink="/app/pdf-summary" target="_blank" class="d-inline-flex align-items-center">
                <mat-icon color="accent" class="me-1">description</mat-icon>
                <span>View Certification Requirements</span>
            </a>
        </div>
        <div [ngSwitch]="question.questionType" class="px-2">
            <div *ngSwitchCase="'userLookup'">
                <app-user-lookup (onUserFound)="onUserFound($event)" [alsdeUser]="alsdeUser"></app-user-lookup>
            </div>
            <div *ngSwitchCase="'cert'">
                <div [ngSwitch]="question.answerType.name">
                    <!-- Free Text Control -->
                    <div class="row" *ngSwitchCase="'text'">
                        <div *ngFor="let answer of question?.selectedAnswers" class="col-12">
                            <mat-form-field appearance="fill" class="w-100 form-field" class="control" >
                                <mat-label>{{ question.placeholder || 'Enter answer here' }}</mat-label>
                                <input matInput [(ngModel)]="answer.answerText" [maxlength]="question.maxLength || null"/>
                                <mat-hint *ngIf="question.maxLength" align="end">
                                    {{ (answer.answerText?.length || 0) }} / {{ question.maxLength }}
                                </mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Dropdown Control -->
                    <div class="row" *ngSwitchCase="'dropdown'">
                        <div  class="col-12">
                            <mat-form-field appearance="fill" class="w-100 form-field">
                                <mat-select placeholder="Select" [(ngModel)]="question.selectedAnswers[0]">
                                <mat-option *ngFor="let answer of question?.answers" [value]="answer">
                                    {{answer.answerText}}
                                </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Yes/No Control -->
                    <div class="card" *ngSwitchCase="'single'" appearance="outline" class="control form-control">
                        <mat-radio-group aria-label="Select Yes or No" [(ngModel)]="selectedAnswers[0]"
                            [disabled]="question.lockAnswers" style="text-align: left;">
                            <div *ngFor="let answer of question?.answers" class="d-flex">
                                <mat-radio-button class="radio-button" [value]="answer.id"
                                    (change)="valueChanged($event, answer)">
                                    <span class="wrap-mat-radio-label" [innerHTML]="getSafeHtml(answer.answerText)"></span>
                                    <input *ngIf="answer.showTextbox && selectedAnswers.includes(answer.id)" (input)="valueChangedTextbox(answer)" matInput class="inline-input" [placeholder]="answer.textboxPlaceholder || ''" [(ngModel)]="answer.textboxValue"/>
                                </mat-radio-button>
                                <mat-icon color="accent-dark" title="More Information" class="answer-tooltip"
                                    *ngIf="answer.tooltip" (click)="answerTooltip(answer.tooltip)">info</mat-icon>
                            </div>
                        </mat-radio-group>
                    </div>

                    <!-- Multi Choice Control -->
                    <div *ngSwitchCase="'multiple'" appearance="outline" class="control form-control">
                        <div class="row">
                            <div class="col-sm-12 text-start column-count-2">
                                <div *ngFor="let answer of question?.answers; let i = index" class="d-flex">
                                    <mat-checkbox class="radio-button mt-0" (change)="valueChanged($event, answer)"
                                        [checked]="selectedAnswers.includes(answer.id)"
                                        [disabled]="question.lockAnswers || disabledOnMaxSelectionsReached(answer)">
                                        <span [innerHTML]="getSafeHtml(answer.answerText)"></span>
                                        <input *ngIf="answer.showTextbox && selectedAnswers.includes(answer.id)" (input)="valueChangedTextbox(answer)" matInput class="inline-input" [placeholder]="answer.textboxPlaceholder || ''" [(ngModel)]="answer.textboxValue"/>
                                    </mat-checkbox>
                                    <mat-icon color="accent-dark" title="More Information" class="answer-tooltip"
                                        *ngIf="answer.tooltip" (click)="answerTooltip(answer.tooltip)">info</mat-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="errorMessage" class="alert alert-danger d-flex align-items-center mt-3 mb-0" role="alert">
        <mat-icon class="me-2" style="color: #c62828;">error_outline</mat-icon>
        <span>{{errorMessage}}</span>
    </div>
    <div class="mt-3 text-start">
        <button [disabled]="questions.length<2" mat-stroked-button color="accent" (click)="back()"
            style="margin-right:5px;">Back</button>
        <button [disabled]="!canNext()" mat-raised-button color="accent" (click)="next()"
            style="margin-left:5px">Next</button>
     </div>
</div>